const state = {
  isVisible: true,
  menuCategory: 'billing',
  items: [
    {
      title: 'billing',
      items: [
        {
          title: 'summary',
          icon: 'tachometer-alt',
          to: 'summary',
        },
        {
          title: 'dataTransfer',
          icon: 'wifi',
          to: 'data_transfer',
        },
        {
          title: 'costAllocationTags',
          icon: 'tags',
          to: 'cost_allocation_tags',
        },
        {
          title: 'cdn',
          icon: 'project-diagram',
          to: 'cdn',
        },
        {
          title: 'costPivot',
          icon: 'table',
          to: 'cost_pivot',
        },
        {
          title: 'costTrend',
          icon: 'chart-line',
          to: 'cost_trend',
        },
        {
          title: 'usageDetail',
          icon: 'th-list',
          to: 'usage_detail',
        },
        {
          title: 'consolidated',
          icon: 'compress-arrows-alt',
          to: 'consolidated',
        },
        {
          title: 'commitmentAnalysis',
          icon: 'chart-bar',
          to: 'commitment_analysis',
        },
        {
          title: 'invoice',
          icon: 'file-alt',
          to: 'invoice',
        },
        {
          title: 'alarm',
          icon: 'bell',
          to: 'alarm',
        },
        {
          title: 'costTable',
          icon: 'book',
          to: 'cost_table',
        },
      ],
    },
    {
      title: 'personal',
      items: [
        {
          title: 'profile',
          icon: 'user-circle',
          to: 'profile',
        },
        {
          title: 'ipAccessControl',
          icon: 'globe',
          to: 'ip_access_control',
        },
      ],
    },
  ],
}

const mutations = {
  menuCategory(state, category) {
    state.menuCategory = category
  },
}
const actions = {
  setMenuCategory({ commit }, category) {
    commit('menuCategory', category)
  },
}
export default {
  namespaced: true,

  state,
  mutations,
  actions,
}
